export { default } from "./footer.svelte";
